import React from "react";
import { useNavigate } from "react-router";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import Header from "../../../../../../components/wizard/Header";
import Progress from "../../../../../../components/wizard/Progress";
import PdfGenerateLink from "../../../../../../components/PdfGenerateLink";

export default function Confirmation({ internalWorkOrder, onClose }) {
  const navigate = useNavigate();
  const moveToItems = () => {
    const pathname = window.location.pathname;
    const params = new URLSearchParams(window.location.search);
    params.set("step", "items");
    navigate({ pathname, search: params.toString() });
  };
  return (
    <Box display="flex" flexDirection="column" justifyContent="space-between" minHeight="100%">
      <Header title="Confirmation" info={internalWorkOrder.internalWorkOrderNumber} />
      <Box p={2}>
        <Box mt={3} display="flex" flexDirection="column" alignItems="center">
          <Box
            component="img"
            borderRadius={2}
            width="100%"
            maxWidth={360}
            src="/shipment-confirmation.webp"
          />
          <Typography mt={5} px={5} textAlign="center" fontSize={18}>
            Your latest updates have been saved and the appropriate parties have been notified.
          </Typography>
          <Box pt={6}>
            <PdfGenerateLink
              resourceType="internal_work_order_pdfs"
              resourceId={internalWorkOrder?.id}
              sx={{ textDecoration: "none", fontWeight: 500, fontSize: 16 }}
              label="Internal Order PDF Link"
            />
          </Box>
        </Box>
      </Box>
      <Box mt={2}>
        <Progress step={3} steps={4} />
        <Box p={2}>
          <Box display="flex" justifyContent="space-between">
            <Button variant="outlined" color="inherit" onClick={moveToItems}>
              Edit Internal Work Order
            </Button>
            <Button onClick={onClose} variant="contained">
              Close
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
